import { FC } from "react";

import styles from "./404.module.scss";

const PageNotFoundView: FC = () => {
  return (
    <div
      id="top"
      data-page-template="base"
      data-page-ready="false"
      data-page-orientation="portrait"
      className={styles.wrapper}
    >
      <div className={styles.container}>
        <div className={styles.logo}>
          <div className={styles.content}>
            <svg
              fill="none"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="#fff">
                <path d="m3.09728 0h17.82972v3.456h-17.82972z" />
                <path d="m5.33514 16.512-2.33514-2.304 9.0243-8.88001 8.9757 8.90401-2.3351 2.28-5.0108-4.968v12.456h-3.3082v-12.456z" />
              </g>
            </svg>
          </div>
        </div>

        <h1>Page Not Found</h1>

        <hr />

        <p>
          The provided URL is not recognised. Please check the address and try
          again.
        </p>

        <p>
          Please contact{" "}
          <a href="mailto:support@livingmap.com">support@livingmap.com</a> for
          assistance.
        </p>
      </div>
    </div>
  );
};

export default PageNotFoundView;
